export enum EstadoSolucion {
  EN_CAPTURA = 'EN_CAPTURA',
  PUBLICADA = 'PUBLICADA',
  ARCHIVADA = 'ARCHIVADA',
  CERRADA = 'CERRADA',
  CANCELADA = 'CANCELADA',
}
